import { ERequestStatus } from '../../types/requestStatus';
import { TRegionListState } from '../../types/regionList';
import { EGetRegionListActionType, TRegionListActions } from '../../actions/regionList';

export const defaultState: TRegionListState = {
  status: ERequestStatus.Initial,
  items: [],
};

export const regionListReducer = (state = defaultState, action: TRegionListActions) => {
  switch (action.type) {
    case EGetRegionListActionType.Succeed:
      return { ...state, ...action.payload, status: ERequestStatus.Succeed };

    default:
      return state;
  }
};
